import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('additives', storeModule.createStoreModule('additives'))
